import { memo } from 'react';

import './TextButton.css';

export enum TextButtonSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}

export enum TextButtonFontSize {
  Large = 'font-large',
  Medium = 'font-medium',
  Small = 'font-small',
}

export enum TextButtonVariant {
  Cyan = 'cyan',
  White = 'white',
  Gray = 'gray',
  Blue = 'blue',
  Green = 'green',
  Purple = 'purple',
  OrangeText = 'orange-text',
  BlueText = 'blue-text',
  Transparent = 'transparent',
  WEABlue = 'WEAblue',
  WEABlueText = 'WEAblue-text',
  Purchased = 'purchased',
}

type TextButtonProps = {
  text: string;
  size?: TextButtonSize;
  fontSize?: TextButtonFontSize;
  variant?: TextButtonVariant;
  disabled?: boolean;
  onClick: () => void;
};

export const TextButton = memo(
  ({
    text,
    size = TextButtonSize.Small,
    fontSize = TextButtonFontSize.Small,
    variant = TextButtonVariant.Cyan,
    disabled,
    onClick,
  }: TextButtonProps) => {
    const className = `text-button ${size} ${variant} ${fontSize} ${
      disabled ? 'disabled' : ''
    }`;
    return (
      <button className={className} disabled={disabled} onClick={onClick}>
        <span>{text}</span>
      </button>
    );
  },
);
